import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  TextField,
  Typography,
  IconButton,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Chip
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";

const PaymentScreenOlympiad = ({ payload, proceed }) => {

  const [coordinators, setCoordinators] = useState([
    {
      name: "",
      email: "",
      mobile: "",
      role: "",
      subjects: []
    }
  ]);

  const [paymentDetails, setPaymentDetails] = useState({
    amount: "",
    mode: "",
    remarks: "",
    attachment: null
  });

  const subjectOptions =
    payload?.olympiadDetails?.classSubjects?.flatMap(cls =>
      cls.subjects.map(s => s.subjectName)
    ) || [];

  // ✅ ADD COORDINATOR
  const addCoordinator = () => {
    setCoordinators([
      ...coordinators,
      { name: "", email: "", mobile: "", role: "", subjects: [] }
    ]);
  };

  // ❌ REMOVE COORDINATOR
  const removeCoordinator = (index) => {
    const updated = coordinators.filter((_, i) => i !== index);
    setCoordinators(updated);
  };

  // ✏️ HANDLE CHANGE
  const handleChange = (index, field, value) => {
    const updated = [...coordinators];
    updated[index][field] = value;
    setCoordinators(updated);
  };

  // 💳 PAYMENT CHANGE
  const handlePaymentChange = (field, value) => {
    setPaymentDetails(prev => ({ ...prev, [field]: value }));
  };

  // 🚀 SUBMIT
  const handleProceed = () => {
    const finalPayload = {
      ...payload,
      coordinators,
      paymentDetails
    };

    console.log(finalPayload);
    proceed(finalPayload);
  };

  return (
    <Box p={2}>

      <Typography variant="h5" mb={2}>
        Coordinator Details
      </Typography>

      {/* 🔹 COORDINATOR CARDS */}
      {coordinators.map((coord, index) => (
        <Card key={index} sx={{ p: 2, mb: 2 }}>
          
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6">
              Coordinator {index + 1}
            </Typography>

            <Box>
              {coordinators.length > 1 && (
                <IconButton onClick={() => removeCoordinator(index)}>
                  <Remove />
                </IconButton>
              )}
              <IconButton onClick={addCoordinator}>
                <Add />
              </IconButton>
            </Box>
          </Box>

          <Grid container spacing={2} mt={1}>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Name"
                value={coord.name}
                onChange={(e) =>
                  handleChange(index, "name", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Email"
                value={coord.email}
                onChange={(e) =>
                  handleChange(index, "email", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Mobile"
                value={coord.mobile}
                onChange={(e) =>
                  handleChange(index, "mobile", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Role"
                value={coord.role}
                onChange={(e) =>
                  handleChange(index, "role", e.target.value)
                }
              />
            </Grid>

            {/* 🔥 MULTI SUBJECT SELECT */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Subjects</InputLabel>
                <Select
                  multiple
                  value={coord.subjects}
                  onChange={(e) =>
                    handleChange(index, "subjects", e.target.value)
                  }
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                      {selected.map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                >
                  {subjectOptions.map((sub, i) => (
                    <MenuItem key={i} value={sub}>
                      {sub}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

          </Grid>
        </Card>
      ))}

      {/* 💳 PAYMENT SECTION */}
      <Typography variant="h5" mt={4} mb={2}>
        Payment Details
      </Typography>

      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Amount"
              type="number"
              value={paymentDetails.amount}
              onChange={(e) =>
                handlePaymentChange("amount", e.target.value)
              }
            />
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Payment Mode</InputLabel>
              <Select
                value={paymentDetails.mode}
                onChange={(e) =>
                  handlePaymentChange("mode", e.target.value)
                }
              >
                <MenuItem value="Cash">Cash</MenuItem>
                <MenuItem value="Online">Online</MenuItem>
                <MenuItem value="Cheque">Cheque</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Remarks"
              multiline
              rows={3}
              value={paymentDetails.remarks}
              onChange={(e) =>
                handlePaymentChange("remarks", e.target.value)
              }
            />
          </Grid>

          {/* 📎 FILE UPLOAD */}
          <Grid item xs={12}>
            <Button variant="outlined" component="label">
              Upload Attachment
              <input
                type="file"
                hidden
                onChange={(e) =>
                  handlePaymentChange("attachment", e.target.files[0])
                }
              />
            </Button>

            {paymentDetails.attachment && (
              <Typography mt={1}>
                {paymentDetails.attachment.name}
              </Typography>
            )}
          </Grid>

        </Grid>
      </Card>

      {/* 🚀 SUBMIT */}
      <Box mt={3} display="flex" justifyContent="flex-end">
        <Button variant="contained" onClick={handleProceed}>
          Proceed
        </Button>
      </Box>

    </Box>
  );
};

export default PaymentScreenOlympiad;